module.exports = __webpack_public_path__ + "assets/banshouli.f71d8d71.svg";